module.exports = __webpack_public_path__ + "static/adi_parth-0fc9ec20755f31751ed5e6c2354c10de.png";